/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CalendarSettings/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import LocationChooser from './LocationChooser/index'
import React from 'react'
import Settings from './Settings/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CalendarSettings({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CalendarSettings"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="CalendarSettings.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-ZCS7wI': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="CalendarSettings.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-ZCS7wI': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Calendar Settings"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Manage the calendar settings for each location"
/>
<LocationChooser
  viewPath={`${viewPath}/LocationChooser`}
/>
</div>
<div
  data-testid="CalendarSettings.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-3-ZCS7wI': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<div
  data-testid="CalendarSettings.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-ZCS7wI': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-4-ZCS7wI': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--g-5-ZCS7wI': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical3}`}
>
<Settings
  viewPath={`${viewPath}/Settings`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}